export default __webpack_public_path__ + "static/media/8.546f3bd3.svg";